import { useContext, useEffect } from 'react';
import { Box } from '@mui/material';

import AuthContext from '../../contexts/AuthContext';
import { ACM } from '../../constants/UserRoles';
import useUploadDocument from './hooks/useUploadDocument';
import DoctorOrTeacherUploadForm from './components/DoctorOrTeacherUploadForm';
import PatientUploadForm from './components/PatientUploadForm';

const UploadDocument = ({ user, typeOfUser }) => {
  const { openVideoUpload } = useContext(AuthContext);
  const hook = useUploadDocument(user, typeOfUser);

  useEffect(() => {
    if (!openVideoUpload) {
      hook.handleClose();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openVideoUpload]);

  return (
    <Box>
      {ACM[typeOfUser]?.isDoctorUploadAttacments ? (
        <DoctorOrTeacherUploadForm
          user={user}
          typeOfUser={typeOfUser}
          hook={hook}
        />
      ) : (
        <PatientUploadForm
          hook={hook}
          isStudentUser={Boolean(ACM[typeOfUser]?.isStudent)}
        />
      )}
    </Box>
  );
};
export default UploadDocument;
